import { defineModule, } from 'direct-vuex';

export interface FindCustomerNumber {
	currentStep: number | null;
    customerNumber: string;
	customerEmail: string;
	customerLastName: string;
    mobileDetails: {
        phoneNumber: string,
        countryCode: string,
    };
}

export default defineModule({
	namespaced: true as const,
	state: {
		currentStep: null as (number | null),
		customerNumber: '',
		customerEmail: '',
		customerLastName: '',
		mobileDetails: {
			phoneNumber: '',
			countryCode: '',
		},
	} as FindCustomerNumber,
	getters: {},
	mutations: {
		setStep(state, step: FindCustomerNumber['currentStep']) {
			state.currentStep = step;
		},
		setCustomerEmail(state, customerEmail) {
			state.customerEmail = customerEmail;
		},
		setCustomerLastNme(state, customerLastName) {
			state.customerLastName = customerLastName;
		},
		setPhoneNumber(state, mobileDetails) {
			state.mobileDetails = { ...mobileDetails, };
		},
		setCustomerNumber(state, customerNumber) {
			state.customerNumber = customerNumber;
		},
		reset(state) {
			state.customerNumber = '';
			state.customerEmail = '';
			state.customerLastName = '';
			state.mobileDetails = {
				phoneNumber: '',
				countryCode: '',
			};
		},
	},
});
